import { render, staticRenderFns } from "./wddialog.vue?vue&type=template&id=b101d20a&scoped=true"
import script from "./wddialog.vue?vue&type=script&lang=js"
export * from "./wddialog.vue?vue&type=script&lang=js"
import style0 from "./wddialog.vue?vue&type=style&index=0&id=b101d20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b101d20a",
  null
  
)

export default component.exports